import React from 'react';
import BookingButton from './BookingButton';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Contact=()=> {
  const location={
    name: "Dudley Clinic (Bailey’s Hair & Beauty)",
    address: "118 The Straits,Dudley DY3 3BA",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2433.456!2d-2.14567!3d52.53456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48709a1358356c57%3A0x7d97609a4788888!2s118%20The%20Straits%2C%20Lower%20Gornal%2C%20Dudley%20DY3%203BA!5e0!3m2!1sen!2suk!4v1710000000000!5m2!1sen!2suk"
  };

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Get in Touch
              </h2>
              <p className="text-gray-600">
                We are based in Dudley and Wolverhampton,ready to help you hear clearly again. Contact us for any general enquiries or to discuss your specific needs.
              </p>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                <div className="p-3 bg-white rounded-full text-rose-gold shadow-sm">
                  <SafeIcon icon={FiIcons.FiMapPin} className="text-xl" />
                </div>

                <div className="space-y-3">
                  <h4 className="font-semibold text-gray-900">
                    Our Location
                  </h4>

                  <div>
                    <p className="text-rose-gold text-xs font-bold uppercase tracking-wider mb-1">
                      Dudley
                    </p>
                    <p className="text-gray-600 text-sm">
                      Bailey’s Hair & Beauty Ltd,118 The Straits,Dudley DY3 3BA
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-4">
                <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                  <div className="p-3 bg-white rounded-full text-rose-gold shadow-sm">
                    <SafeIcon icon={FiIcons.FiMail} className="text-xl" />
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-900">
                      Email Us
                    </h4>
                    <p className="text-gray-600 text-sm">
                      hillearcare@gmail.com
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                  <div className="p-3 bg-white rounded-full text-rose-gold shadow-sm">
                    <SafeIcon icon={FiIcons.FiPhone} className="text-xl" />
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-900">
                      Call Us
                    </h4>
                    <p className="text-gray-600 text-sm">
                      07960 998464
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <div className="h-[400px] bg-gray-100 rounded-2xl overflow-hidden shadow-inner relative border border-gray-100">
              <iframe
                src={location.mapUrl}
                width="100%"
                height="100%"
                style={{border: 0}}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Dudley Location"
              />
            </div>

            <p className="text-center text-xs text-gray-400">
              Showing our Dudley Clinic at Bailey’s Hair & Beauty.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;